import { render, staticRenderFns } from "./CartShopItem.vue?vue&type=template&id=45d5309f&"
import script from "./CartShopItem.vue?vue&type=script&lang=js&"
export * from "./CartShopItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports